import { Actions } from './actions';

const { change: changeLocation, replace: replaceLocation } = Actions;

export { changeLocation, replaceLocation };

export { urlLocationMiddleware } from './middlewares/urlLocationMiddleware';
